export enum ModelType {
    None = 0,  
    Automotive = 1,
    Industrial = 2
  }